import React from "react";
import { ToggleInputPropsType } from "../../../constants/interface";

const ToggleInput: React.FC<ToggleInputPropsType> = ({
  isChecked,
  handleToggle,
}) => {
  const toggleButtonStyle = {
    transform: isChecked ? "translateX(130%)" : "translateX(0)",
  };

  return (
    <button
      type="button"
      title="push-notification"
      onClick={handleToggle}
      className={`flex items-center ${
        isChecked ? "justify-start" : "justify-start"
      } ${
        isChecked ? "bg-main" : "bg-red-500"
      } w-10 h-5 px-[2px] rounded-full flex transition duration-300 ease-linear shadow-2xl`}
    >
      <span
        className={`bg-white transition duration-300 ease-linear rounded-full w-4 h-4 m-0 p-0 shadow-xl`}
        style={toggleButtonStyle}
      ></span>
    </button>
  );
};

export default ToggleInput;
